import Vue from 'vue';
import App from './App.vue';
// import "./registerServiceWorker";
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import httpClient from './api/httpClient';
import dateFilter from './helpers/filters/date';
import numeralFilter from './helpers/filters/numeral';
import stringFilter from './helpers/filters/string';
import images from '@/helpers/enums/images';
import enums from '@/helpers/enums';
import LoadingSpinner from '@/components/common/LoadingSpinner';
import LoadingSpinnerDialog from '@/components/common/LoadingSpinnerDialog';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import rules from '@/helpers/rules';
import mixins from './plugins/mixins';
import PortalVue from 'portal-vue';

Vue.prototype.$images = images;
Vue.prototype.$rules = rules;
Vue.prototype.$enums = enums;

Vue.filter('normalDate', dateFilter.normalDate);
Vue.filter('normalDateWithTime', dateFilter.normalDateWithTime);
Vue.filter('longDate', dateFilter.longDate);
Vue.filter('longDateWithTime', dateFilter.longDateWithTime);
Vue.filter('time', dateFilter.time);
Vue.filter('one_decimal', numeralFilter.one_decimal);
Vue.filter('no_decimal', numeralFilter.no_decimal);
Vue.filter('no_decimal_abs', numeralFilter.no_decimal_abs);
Vue.filter('lower', stringFilter.lower);
Vue.filter('capitalize', stringFilter.capitalize);
Vue.filter('separator', numeralFilter.separator);
Vue.filter('ordinal_words', numeralFilter.ordinal_words);
Vue.filter('currency', numeralFilter.currency);
Vue.filter('currencyShort', numeralFilter.currencyShort);
Vue.filter('currencyBig', numeralFilter.currencyBig);
Vue.filter('currencySmall', numeralFilter.currencySmall);
Vue.filter('currencyAi', numeralFilter.currencyAi);
Vue.filter('percentage', numeralFilter.percentage);
Vue.filter('year', dateFilter.year);
Vue.filter('monthDate', dateFilter.monthDate);

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_URL,
  environment: process.env.NODE_ENV,
  integrations: [
    new VueIntegration({
      Vue,
      logErrors: true,
      attachProps: true
    })
  ],
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0
});

Vue.component('LoadingSpinner', LoadingSpinner);
Vue.component('LoadingSpinnerDialog', LoadingSpinnerDialog);

Vue.prototype.$http = httpClient;
Vue.prototype.$bus = new Vue();
Vue.config.productionTip = false;
Vue.mixin(mixins);
Vue.use(PortalVue);

Vue.config.devtools = true;

new Vue({
  router,
  store,
  vuetify,
  created() {},
  render: (h) => h(App)
}).$mount('#app');
